import React from 'react';
import Firebase from 'firebase';
import { Tooltip, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


export default class adminsItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tooltipOpen: false,
        }
    }

    componentWillMount() {
        var clientRef = Firebase.database().ref('clients')
            .child(this.props.admin.client_id)
            .once('value')
            .then(resp => {
                this.setState({ client: resp.val().name })
            });
    }

    render() {
        var toltip_id = "toltip_" + Math.floor((Math.random() * 100) + 1);
        return (
            <tr style={{ cursor: "pointer" }}>
                <td>{this.props.admin.name}</td>
                <td>
                    <i className="fa fa-info" id={toltip_id} aria-hidden="true"></i>{"  " + this.props.admin.client_id}
                    <Tooltip placement="bottom" isOpen={this.state.tooltipOpen} target={toltip_id}
                        toggle={() => this.setState({ tooltipOpen: !this.state.tooltipOpen })}>
                        Nombre: {this.state.client}
                    </Tooltip>
                </td>
                <td>{this.props.admin.email}</td>
                <td>{this.props.admin.rut}</td>
                <td>
                    <button className="btn btn-outline-success" style={{ cursor: "pointer" }} onClick={() => this.props.callBack(this.props.adminId)} >
                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </button>
                    {"  "}
                    <button className="btn btn-outline-danger" onClick={() => { this.props.deleteUser(this.props.adminId, this.props.admin.client_id) }} >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                </td>
            </tr >
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/administracion/admins/adminsItem.js